import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setToRetrieveCounter } from '../../../orderSlice';

export default function useExternalTotalCountSync({
  isSuccessPending,
  isSuccessIncomplete,
  totalCount,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isSuccessPending || isSuccessIncomplete) {
      dispatch(setToRetrieveCounter(totalCount || 0));
    }
  }, [dispatch, isSuccessIncomplete, isSuccessPending, totalCount]);
}
